/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Categories1Inputs */

const id_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori`)
};

const ms_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori`)
};

const da_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorier`)
};

const de_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorien`)
};

const en_us2_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categories`)
};

const es_es2_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorías`)
};

const es_mx2_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorías`)
};

const fil_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Kategorya`)
};

const fr_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégories`)
};

const it_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorie`)
};

const hu_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategóriák`)
};

const nl_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorieën`)
};

const no_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorier`)
};

const pl_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie`)
};

const pt_br2_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorias`)
};

const pt_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorias`)
};

const ro_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorii`)
};

const fi_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategoriat`)
};

const sv_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorier`)
};

const vi_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục`)
};

const tr_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategoriler`)
};

const cs_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie`)
};

const bg_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Категории`)
};

const ru_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Категории`)
};

const uk_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Категорії`)
};

const ar_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفئات`)
};

const hi_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`श्रेणियाँ`)
};

const th_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หมวดหมู่`)
};

const ja_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カテゴリ`)
};

const zh_cn2_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类`)
};

const zh_hant1_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分類`)
};

const ko_offerdetail_table_categories1 = /** @type {(inputs: Offerdetail_Table_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카테고리`)
};

/**
* | output |
* | --- |
* | "Categories" |
*
* @param {Offerdetail_Table_Categories1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_categories1 = /** @type {((inputs?: Offerdetail_Table_Categories1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Categories1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_categories1(inputs)
	if (locale === "ms") return ms_offerdetail_table_categories1(inputs)
	if (locale === "da") return da_offerdetail_table_categories1(inputs)
	if (locale === "de") return de_offerdetail_table_categories1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_categories1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_categories1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_categories1(inputs)
	if (locale === "fil") return fil_offerdetail_table_categories1(inputs)
	if (locale === "fr") return fr_offerdetail_table_categories1(inputs)
	if (locale === "it") return it_offerdetail_table_categories1(inputs)
	if (locale === "hu") return hu_offerdetail_table_categories1(inputs)
	if (locale === "nl") return nl_offerdetail_table_categories1(inputs)
	if (locale === "no") return no_offerdetail_table_categories1(inputs)
	if (locale === "pl") return pl_offerdetail_table_categories1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_categories1(inputs)
	if (locale === "pt") return pt_offerdetail_table_categories1(inputs)
	if (locale === "ro") return ro_offerdetail_table_categories1(inputs)
	if (locale === "fi") return fi_offerdetail_table_categories1(inputs)
	if (locale === "sv") return sv_offerdetail_table_categories1(inputs)
	if (locale === "vi") return vi_offerdetail_table_categories1(inputs)
	if (locale === "tr") return tr_offerdetail_table_categories1(inputs)
	if (locale === "cs") return cs_offerdetail_table_categories1(inputs)
	if (locale === "bg") return bg_offerdetail_table_categories1(inputs)
	if (locale === "ru") return ru_offerdetail_table_categories1(inputs)
	if (locale === "uk") return uk_offerdetail_table_categories1(inputs)
	if (locale === "ar") return ar_offerdetail_table_categories1(inputs)
	if (locale === "hi") return hi_offerdetail_table_categories1(inputs)
	if (locale === "th") return th_offerdetail_table_categories1(inputs)
	if (locale === "ja") return ja_offerdetail_table_categories1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_categories1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_categories1(inputs)
	return ko_offerdetail_table_categories1(inputs)
});
export { offerdetail_table_categories1 as "offerDetail.table.categories" }